import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=f3f6d652&scoped=true&"
import script from "./BigScreen.vue?vue&type=script&lang=js&"
export * from "./BigScreen.vue?vue&type=script&lang=js&"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=f3f6d652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f6d652",
  null
  
)

export default component.exports